module.exports = __webpack_public_path__ + "static/img/expedijob.19a2030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/expedijob.png
// module id = azgG
// module chunks = 1 2